// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"498":"4828a3de","934":"4828a3de"}[chunkId] + ".chunk.css";
};